import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { baseItemStyle as SideMenuItemBaseStyle, leftSideBeforeElementSize, itemXPadding as sideMenuItemXPadding, getLeftSideBeforeElementCssWithColor, getLinkItemBg, } from "../../../organisms/SideMenu/SideMenu.styles";
import { textStyles } from "../../../../theme/foundations/generated";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["anchor", "text", "leftIcon", "rightIcon"]);
const baseStyle = definePartsStyle({
    anchor: {
        display: "inline-flex",
        alignItems: "center",
        _disabled: {
            pointerEvents: "none",
        },
        _hover: {
            textDecoration: "none",
        },
        _active: {},
        _focusVisible: {
            outline: ".1875rem solid",
            outlineOffset: ".125rem",
        },
    },
    text: {
        borderBottom: ".125rem solid",
    },
    leftIcon: {
        width: "1.5rem",
        height: "1.5rem",
        mr: "3",
    },
    rightIcon: {
        width: "1.5rem",
        height: "1.5rem",
        ml: "3",
    },
});
const sizes = {
    small: definePartsStyle({
        anchor: {},
        text: textStyles.body.smallDemibold,
        leftIcon: {
            mr: "2",
        },
        rightIcon: {
            ml: "2",
        },
    }),
    medium: definePartsStyle({
        anchor: {},
        text: textStyles.body.mediumDemibold,
        leftIcon: {},
        rightIcon: {},
    }),
    large: definePartsStyle({
        anchor: {},
        text: textStyles.body.largeDemibold,
    }),
};
const variants = {
    default: definePartsStyle({
        anchor: {
            color: "semantic.cta.secondary",
            _disabled: {
                color: "semantic.text.disabled",
            },
            _hover: {
                color: "semantic.text.hover",
            },
            _active: {
                color: "semantic.cta.secondaryPressed",
            },
            _focusVisible: {
                outlineColor: "semantic.outline.focus",
            },
        },
    }),
    primary: definePartsStyle({
        anchor: {
            borderBottom: ".125rem solid",
            borderColor: "transparent",
            color: "semantic.text.primary",
            _disabled: {
                color: "semantic.text.disabled",
            },
            _hover: {
                color: "semantic.text.hover",
                borderColor: "semantic.text.hover",
            },
            _active: {
                color: "semantic.cta.secondaryPressed",
                borderColor: "semantic.text.hover",
            },
            _focusVisible: {
                outlineColor: "semantic.outline.focus",
                borderColor: "semantic.text.hover",
            },
        },
        text: {
            border: "none",
        },
    }),
    header: definePartsStyle(({ isSelected }) => ({
        anchor: Object.assign({ height: "100%", px: 3, color: "semantic.text.primary", borderBottom: "4px solid", borderColor: "transparent", whiteSpace: "nowrap", _disabled: {
                color: "semantic.text.disabled",
            }, _hover: {
                color: "semantic.text.primary",
                backgroundColor: "semantic.cta.secondaryHover",
                borderColor: "semantic.outline.focus",
            }, _active: {
                color: "semantic.text.inverse",
                backgroundColor: "semantic.cta.secondaryPressed",
            }, _focusVisible: {
                color: "semantic.text.primary",
                outlineOffset: "-0.125rem",
                outlineColor: "semantic.outline.focus",
                backgroundColor: "semantic.cta.secondaryHover",
            } }, (isSelected && {
            color: "semantic.text.primary",
            borderColor: "semantic.outline.focus",
        })),
        text: Object.assign({ border: "none" }, textStyles.body.largeDemibold),
    })),
    sideMenu: definePartsStyle(({ isNested, isNestedRoot, hasSelectedSiblings, backOfficeMode, }) => ({
        anchor: Object.assign(Object.assign({}, SideMenuItemBaseStyle(isNested, isNestedRoot, false, hasSelectedSiblings, backOfficeMode)), { position: "relative", width: { base: "9.5rem", md: "100%" }, justifyContent: { base: "center", md: "flex-start" }, textAlign: { base: "center", md: "left" } }),
        text: { borderBottom: "none", fontWeight: "core.medium" },
        leftIcon: { pr: sideMenuItemXPadding },
        rightIcon: {},
    })),
    sideMenuIsSelected: definePartsStyle(({ isNested, isNestedRoot, isSideMenuExpanded, hasSelectedSiblings, backOfficeMode, }) => ({
        anchor: Object.assign(Object.assign({}, SideMenuItemBaseStyle(isNested, isNestedRoot, true, hasSelectedSiblings, backOfficeMode)), { position: "relative", width: { base: "9.5rem", md: "100%" }, justifyContent: { base: "center", md: "flex-start" }, textAlign: { base: "center", md: "left" }, backgroundColor: getLinkItemBg(backOfficeMode), color: "semantic.text.primary", _before: isNestedRoot && isSideMenuExpanded
                ? {}
                : getLeftSideBeforeElementCssWithColor(backOfficeMode
                    ? "semantic.brand.tertiary"
                    : "semantic.brand.secondary"), _hover: {
                _before: isNestedRoot && isSideMenuExpanded
                    ? {}
                    : getLeftSideBeforeElementCssWithColor("semantic.brand.tertiary"),
                backgroundColor: "semantic.brand.tertiary-dimmed",
                color: "semantic.text.primary",
                textDecoration: "none",
            } }),
        text: { borderBottom: "none", fontWeight: "600" },
        leftIcon: {
            pr: sideMenuItemXPadding,
            ml: isNestedRoot && isSideMenuExpanded
                ? 0
                : `-${leftSideBeforeElementSize}`,
        },
        rightIcon: {},
    })),
};
const LinkTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
    defaultProps: {
        variant: "default",
        size: "medium",
    },
});
export default LinkTheme;
//# sourceMappingURL=Link.default.js.map